export const servicesData = [
  {
    group: "E-Belge Modülü",
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />
      </svg>
    ),
    items: [
      { title: "E-Defter ile Uyum", desc: "E-Defter Modülü ile E-Fatura Modülü Tam Entegre Çalışmaktadır.", tag: "Tam Entegre" },
      { title: "Tahmini Vergi Projeksiyonu", desc: "KDV, KDV2, Stopaj, ÖTV gibi vergilerin toplu anlık projeksiyonu.", tag: "Tam Entegre" },
      { title: "20+ Entegratör", desc: "Web Servis teknolojisi ile anlık tüm mükellef faturaları bir arada.", tag: "Tam Entegre" },
      { title: "Satır Satır Detaylar", desc: "Tüm Faturalar Satır bazında anlık elinizin altında.", tag: "Tam Entegre" },
    ]
  },
  {
    group: "E-Defter Modülü",
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
      </svg>
    ),
    items: [
      { title: "Program Bağımsız", desc: "Tüm programlardan gelen E-Defterler tek bir altyapıda.", tag: "Aktif" },
      { title: "E-Fatura Entegrasyonu", desc: "Yevmiye fişi ve muavin içinde fatura görüntüleme ve raporlama.", tag: "Aktif" },
      { title: "Benzersiz Analizler", desc: "Mizan, muavin, anlık döviz raporlama, fiş türüne göre kategorizasyon.", tag: "Hızlı" },
      { title: "Toplu E-Defter Yönetimi", desc: "Toplu ve tüm yıllar için tek ekranda kontrol yeteneği.", tag: "Hızlı" },
    ]
  },
  {
    group: "E-Beyanname",
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
      </svg>
    ),
    items: [
      { title: "Beyannameler", desc: "Tüm Grup Meslek Mensupları ve Müşteriler tek ekrandan Beyanname Yönetimi.", tag: "Yeni" },
      { title: "Beyanname Raporları", desc: "Tüm firmaların anlık Beyanname Ekran ve Excel Özetleri.", tag: "Aktif" },
      { title: "Mali Tablolar", desc: "Tüm Firmaların Toplu mali tablo raporlaması.", tag: "Aktif" },
      { title: "Beyanname İndirme ve Paylaşma", desc: "Tüm firmaların beyannameleri kolay indirme ve WhatsApp paylaşma özelliği.", tag: "Aktif" },
    ]
  },
  {
    group: "Dijital Uygulamalar",
    icon: (
      <svg fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
      </svg>
    ),
    items: [
      { title: "Şifresiz E-Beyanname Girişi", desc: "Kolaylaştırılmış, şifre gerektirmeyen dijital beyanname girişi.", tag: "Aktif" },
      { title: "Dijital GİB Girişi", desc: "Şifresiz Dijital GİB Girişi ve anlık sorgulama.", tag: "Aktif" },
      { title: "Çoklu Sorgulama", desc: "Anlık Tebligat, Borç, Araç, Haciz, İban, Emanet ve daha fazlası.", tag: "Aktif" },
      { title: "Otomatik Beyanname İndirme", desc: "Her gece sizin yerinize çalışır, tasnifler ve raporlar.", tag: "Aktif" },
    ]
  }
];
